import React from "react";
import LedgerReport from "./ledgerReport";

const REPORT_TYPES = [
  { value: "incomecontr", label: "Income from Contributions" },
  { value: "incomecontrpnlt", label: "Income from Penalties on Contributions" },
  { value: "incomepnltothers", label: "Income from Penalties on Absence & Latency" },
  { value: "incomeloan", label: "Income from Loans" },
  { value: "incomeinvest", label: "Income from Investment" },
  { value: "incomeother", label: "Income from Others" },
  { value: "mreserve", label: "Monthly Reserves" },
  { value: "incomeunidentified", label: "Unindentified" },
  { value: "allreceivables", label: "Receivables" },
  { value: "allpayables", label: "Payable" },
];

export default function IncomeReport() {
  return (
    <LedgerReport
      name="incomeReport"
      title="Incomes:"
      partyLabel="Payer"
      reportTypes={REPORT_TYPES}
      defaultType="incomecontr"
      balanceTypes={["allreceivables", "allpayables"]}
      downloadName="Income.xlsx"
    />
  );
}
